import type { InventoryItem } from '@/types/inventory';

/**
 * P0 variant-stock fix — single source of truth for how a catalog row
 * renders in stock / order / PO pickers. Variants surface as
 * `{Parent name} · {attr1} · {attr2}` so operators don't have to
 * decode SKU patterns; standalone items render as plain `{name}`.
 *
 * Pair with `pickerSku(item)` for the muted secondary line.
 */
export function pickerLabel(item: InventoryItem): string {
  if (item.parent && item.variantAttributes) {
    const attrs = Object.values(item.variantAttributes).filter(Boolean);
    return attrs.length > 0
      ? `${item.parent.name} · ${attrs.join(' · ')}`
      : item.parent.name;
  }
  return item.name;
}

/** Secondary line — SKU on standalone items, variant SKU on variants. */
export function pickerSku(item: InventoryItem): string {
  return item.sku;
}

/**
 * True when this row represents a parent template that can't hold
 * stock. Pickers should hide these — and the BE's `pickable=true`
 * filter does it server-side — but a defensive runtime check costs
 * nothing and protects against stale caches.
 */
export function isPickerHidden(item: InventoryItem): boolean {
  return item.hasVariants === true;
}
